import { Dialog, Transition } from "@headlessui/react";
import cx from "classnames";
import { Fragment } from "react";

import { Button, Heading, Link, List } from "@icg360/design-system";

import { openSupportChat } from "utils";

import styles from "./ss1.module.scss";

type SageSureOneModalProps = {
  open: boolean;
  onClose?: () => void;
};

export const SageSureOneModal = ({ open, onClose }: SageSureOneModalProps) => {
  const handleClose = onClose ?? (() => {});

  return (
    <Transition show={open} as={Fragment}>
      <Dialog onClose={handleClose} className={styles.dialog}>
        <Transition.Child
          as={Fragment}
          enter={styles.backdropEnter}
          enterFrom={styles.backdropHidden}
          enterTo={styles.backdropVisible}
          leave={styles.backdropLeave}
          leaveFrom={styles.backdropVisible}
          leaveTo={styles.backdropHidden}
        >
          <div className={styles.backdrop} aria-hidden="true" />
        </Transition.Child>

        <div className={styles.container}>
          <Transition.Child
            as={Fragment}
            enter={styles.panelEnter}
            enterFrom={styles.panelHidden}
            enterTo={styles.panelVisible}
            leave={styles.panelLeave}
            leaveFrom={styles.panelVisible}
            leaveTo={styles.panelHidden}
          >
            <Dialog.Panel className={styles.panel}>
              <header className={styles.modalHeader}>
                <img
                  className={styles.logo}
                  src="/assets/images/ss1-one.svg"
                  alt="SageSure One"
                />
                <Button
                  icon="Close"
                  size="sm"
                  appearance="tertiary"
                  onClick={handleClose}
                />
              </header>
              <section className={styles.modalHero}>
                <Dialog.Title as={Heading} size="sm">
                  Experience SageSure One
                </Dialog.Title>
                <p className="body-lg-regular">
                  Your policy includes support and care designed for your home.
                </p>
              </section>
              <List type="icon">
                <List.Item iconName="Meeting">
                  <p className={cx("body-md-medium", styles.listHead)}>
                    Get brilliant support before you need it
                  </p>
                  <p className={cx("body-sm-regular", styles.listDesc)}>
                    Your One Consultant partners with your agent for seamless
                    experiences.
                  </p>
                </List.Item>
                <List.Item iconName="ModernHome">
                  <p className={cx("body-md-medium", styles.listHead)}>
                    Be the expert of your domain
                  </p>
                  <p className={cx("body-sm-regular", styles.listDesc)}>
                    Your home's data helps you make informed coverage decisions.
                  </p>
                </List.Item>
                <List.Item iconName="SearchSpark">
                  <p className={cx("body-md-medium", styles.listHead)}>
                    Simplify recovery
                  </p>
                  <p className={cx("body-sm-regular", styles.listDesc)}>
                    Get help from claims specialists who understand unique
                    homes.
                  </p>
                </List.Item>
                <List.Item iconName="Lightbulb">
                  <p className={cx("body-md-medium", styles.listHead)}>
                    Build your home’s resilience
                  </p>
                  <p className={cx("body-sm-regular", styles.listDesc)}>
                    Get complimentary smart home technology to help prevent
                    damage before it starts.
                  </p>
                </List.Item>
              </List>
              <footer className={styles.modalFooter}>
                <Link
                  inverse
                  appearance="secondary"
                  href="https://sagesure.com/wp-content/uploads/dlm_uploads/2026/08/SageSure-One-Client-FAQs.pdf"
                  target="_blank"
                  className={styles.faqBtn}
                >
                  View FAQs
                </Link>
                <Button
                  appearance="primary"
                  inverse
                  onPress={openSupportChat}
                  className={styles.closeBtn}
                >
                  Chat with your One Consultant
                </Button>
              </footer>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};
